module.exports = __webpack_public_path__ + "static/media/ICML2022.77168e74.ipynb";